import React from 'react';
import DSPaper from '../../../design-system/Paper/DSPaper';
import DSCircularProgress from '../../../design-system/DSCircularProgress';
import { useTheme } from '@mui/material';

const KlydoChimeInputLoading = () => {
  const { palette, spacing } = useTheme();

  return (
    <DSPaper
      sx={{
        display: 'flex',
        padding: spacing(2, 3),
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch',
        borderRadius: '28px',
        border: `2px dashed ${palette.white[12]}`,
        background: 'transparent',
      }}
    >
      <DSCircularProgress size={24} />
    </DSPaper>
  );
};

export default KlydoChimeInputLoading;
